import { PackageOfferingBreakdown } from "app/shared/model/EditPricelist";
import { normalizeRecurranceStartDays } from "../dateStrategy/recurranceDays";

export function mapPackageOfferingBreakdowns(source: unknown): PackageOfferingBreakdown[] {
  if (!source || typeof source !== "object") return [];
  const product = source as Record<string, unknown>;
  const raw =
    product.packageOfferingBreakdowns ??
    product.packageOfferingBreakdown ??
    product.packageBreakdowns ??
    product.PackageBreakdowns ??
    product.breakdowns ??
    product.Breakdowns;

  if (!Array.isArray(raw)) return [];

  return raw
    .map((b: unknown) => {
      if (!b || typeof b !== "object") return null;
      const row = b as Record<string, unknown>;
      const productId = Number(row.productId ?? row.ProductId ?? 0);
      const productTypeId = Number(row.productTypeId ?? row.ProductTypeId ?? 0);
      const percentageBreakdown = Number(
        row.percentageBreakdown ??
          row.PercentageBreakdown ??
          row.percentage ??
          row.Percentage ??
          0
      );
      if (!Number.isFinite(productId) || productId <= 0) return null;
      return {
        productId,
        productTypeId: Number.isFinite(productTypeId) ? productTypeId : 0,
        percentageBreakdown: Number.isFinite(percentageBreakdown) ? percentageBreakdown : 0,
      } as PackageOfferingBreakdown;
    })
    .filter((x): x is PackageOfferingBreakdown => x != null);
}

export function resolveFeeUnitTypeId(fee: Record<string, unknown>): number | undefined {
  const candidates = [
    fee.feeUnitTypeId,
    fee.FeeUnitTypeId,
    fee.unitTypeId,
    fee.UnitTypeId,
    (fee.unitType as Record<string, unknown> | undefined)?.id,
    (fee.unitType as Record<string, unknown> | undefined)?.Id,
    (fee.feeUnitType as Record<string, unknown> | undefined)?.id,
    (fee.feeUnitType as Record<string, unknown> | undefined)?.Id,
  ];

  for (const c of candidates) {
    const n = Number(c);
    if (Number.isFinite(n) && n > 0) return n;
  }

  const fot = String(fee.feeOfferingType ?? fee.FeeOfferingType ?? "").trim();
  if (fot === "2" || fot.toLowerCase() === "one off" || fot.toLowerCase() === "oneoff") {
    return 2;
  }
  if (fot === "1" || fot.toLowerCase() === "supplement") {
    return 1;
  }

  return undefined;
}

export function mapDateStrategyAssignments(dateStrategies: unknown[]): Record<string, unknown>[] {
  return dateStrategies.map((ds: any) => ({
    id: ds.id ?? ds.Id,
    strategyTypeId: Number(ds.strategyTypeId ?? ds.StrategyTypeId ?? 0),
    fromDate: ds.fromDate ?? ds.FromDate,
    toDate: ds.toDate ?? ds.ToDate ?? null,
    lastStartDate: ds.lastStartDate ?? ds.LastStartDate ?? null,
    recurranceStartDays: normalizeRecurranceStartDays(
      ds.recurranceStartDays ?? ds.RecurranceStartDays
    ),
    specificStartDates: Array.isArray(ds.specificStartDates ?? ds.SpecificStartDates)
      ? ds.specificStartDates ?? ds.SpecificStartDates
      : [],
    fixedDurationDates: Array.isArray(ds.fixedDurationDates ?? ds.FixedDurationDates)
      ? ds.fixedDurationDates ?? ds.FixedDurationDates
      : [],
    originalFromDate: ds.originalFromDate ?? ds.OriginalFromDate ?? ds.fromDate ?? ds.FromDate,
    originalToDate: ds.originalToDate ?? ds.OriginalToDate ?? ds.toDate ?? ds.ToDate ?? null,
    isArchived: Boolean(ds.isArchived ?? ds.IsArchived),
    isNew: Boolean(ds.isNew ?? ds.IsNew),
  }));
}